import api from './axios';

// ── Types (match backend contract) ─────────────────────────────────────────────

export interface RetentionDisk {
  usedBytes: number;
  freeBytes: number;
  totalBytes: number;
  percentUsed: number;
  logDirBytes: number;
  backupsDirBytes: number;
}

export interface PurgeStat {
  table: string;
  scope: 'registry' | 'tenant';
  totalRows: number | null;
  purgeableRows: number | null;
}

export interface KeepStat {
  table: string;
  scope: 'registry' | 'tenant';
  totalRows: number | null;
}

export interface RetentionRun {
  run_id: string;
  triggered_by: string;
  started_at: string;
  finished_at: string | null;
  duration_ms: number | null;
  files_deleted: number;
  registry_rows: number;
  tenant_rows: number;
  status?: string;
  [key: string]: unknown;
}

export interface RetentionStats {
  purge: PurgeStat[];
  keep: KeepStat[];
  recentRuns: RetentionRun[];
}

export interface RetentionStatus {
  disk: RetentionDisk;
  policy: Record<string, unknown>;
  stats: RetentionStats;
  cutoffDays: number;
}

export interface RetentionRunSummary {
  files: number;
  registry: { total: number; byTable: Record<string, number> };
  tenant: { total: number; tenants: number };
  durationMs: number;
}

// ── API ─────────────────────────────────────────────────────────────────────

export const getStatus = (): Promise<{ data: RetentionStatus }> =>
  api.get('/super-admin/retention/status');

export const run = (): Promise<{ data: RetentionRunSummary }> =>
  api.post('/super-admin/retention/run');
